import Base from "../Base";

export default class Flexible extends Base {
  init(id, main, locale) {
    console.log(":: Flexible ::");
  }
}
